import { useMember } from '@tribeplatform/react-sdk/hooks'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { getLocalizedDateFormat } from '../../common/utils/date.js'
import { T, useI18n } from '../../i18n/index.js'

interface Props {
  memberId: string
}

export const MemberAbout = ({ memberId }: Props) => {
  const { data: member } = useMember({ variables: { id: memberId } })
  const { localeCode } = useI18n()
  const { date: createdAtDate } = getLocalizedDateFormat(
    member?.createdAt,
    localeCode,
  )

  if (!member) {
    return null
  }

  return (
    <div className="flex flex-col gap-5 p-3">
      <div className="text-sm text-content-muted">
        <T id="Generics.About" defaultMessage="About" />
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-1">
          <Text variant="bodySm">
            <T id="Generics.Tagline" defaultMessage="Tagline" />
          </Text>
          <Text variant="bodySm" className="text-content-muted">
            {member.tagline ?? '...'}
          </Text>
        </div>
        <div className="flex flex-col gap-1">
          <Text variant="bodySm">
            <T id="Generics.MemberSince" defaultMessage="Member since" />
          </Text>
          <Text variant="bodySm" className="text-content-muted">
            {createdAtDate}
          </Text>
        </div>
      </div>
    </div>
  )
}
